/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_2_DescInputs */

const en_mk_agent_2_desc = /** @type {(inputs: Mk_Agent_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent may draft a broadcast, answer a complaint or schedule a post — but it asks first. You approve, ask for a revision, or reject.`)
};

const id_mk_agent_2_desc = /** @type {(inputs: Mk_Agent_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen boleh menyusun broadcast, membalas keluhan, atau menjadwalkan unggahan — tapi ia mengajukan izin lebih dulu. Anda menyetujui, meminta revisi, atau menolak.`)
};

/**
* | output |
* | --- |
* | "An agent may draft a broadcast, answer a complaint or schedule a post — but it asks first. You approve, ask for a revision, or reject." |
*
* @param {Mk_Agent_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_2_desc = /** @type {((inputs?: Mk_Agent_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_2_desc(inputs)
	return en_mk_agent_2_desc(inputs)
});